import { Link } from "react-router-dom"

export const GreenButton = ({ text, click, link, isMobileFull, isFull, icon, disabled }) => {
    return (
        <Link to={link}><button className={`${disabled ? 'border-2 border-neutral-300 text-neutral-300 cursor-default' : 'bg-[#225424] text-white'} py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl ${isMobileFull ? 'w-full md:w-fit' : (isFull ? 'w-full' : 'w-fit')}`} onClick={click}>
            {icon && icon} {text}
        </button></Link>
    )
}

export const BrownButton = ({ text, click, link, isMobileFull, isFull, icon, disabled }) => {
    return (
        <Link to={link}><button className={`${disabled ? 'border-2 border-neutral-300 text-neutral-300 cursor-default' : 'bg-[#b05704] text-white'} py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl ${isMobileFull ? 'w-full md:w-fit' : (isFull ? 'w-full' : 'w-fit')}`} onClick={click}>
            {icon && icon} {text}
        </button></Link>
    )
}

export const GreyButton = ({ text, click, link, isMobileFull, isFull, icon, disabled }) => {
    return (
        <Link to={link}><button className={`${disabled ? 'border-2 border-neutral-300 text-neutral-300 cursor-default' : 'bg-neutral-200 text-[#225424]'} py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl ${isMobileFull ? 'w-full md:w-fit' : (isFull ? 'w-full' : 'w-fit')}`} onClick={click}>
            {icon && icon} {text}
        </button></Link>
    )
}


export const NoBgButton = ({ text, click, link, isMobileFull, isFull, icon }) => {
    return (
        <Link to={link}><button className={`border border-[#225424] py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl ${isMobileFull ? 'w-full md:w-fit' : (isFull ? 'w-full' : 'w-fit')}`} onClick={click}>
            {icon} {text}
            </button></Link>
    )
}

export const NoBorderWhiteButton = ({ text, click, link, isMobileFull, isFull, icon }) => {
    return (
        <Link to={link}><button className={`bg-white py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl ${isMobileFull ? 'w-full md:w-fit' : (isFull ? 'w-full' : 'w-fit')}`} onClick={click}>
            {icon} {text}
            </button></Link>
    )
}

export const YellowButton = ({ text, click, link, isMobileFull, isFull, icon, disabled }) => {
    return (
        <Link to={link}><button className={`${disabled ? 'border-2 border-neutral-300 text-neutral-300 cursor-default' : 'bg-[#fbd100] text-white font-bold'} py-4 px-8 md:py-2 text-xl md:text-sm rounded-xl ${isMobileFull ? 'w-full md:w-fit' : (isFull ? 'w-full' : 'w-fit')}`} onClick={click}>
            {icon && icon} {text}
        </button></Link>
    )
}